import React from 'react';
import { AppProvider } from './providers/AppProvider';

function App() {
  return /*#__PURE__*/React.createElement(AppProvider, null);
}

export default App;